import { useState } from 'react';
import {
    END_DATE_ERROR,
    ITEM_ERROR,
    MIN_AMOUNT_ERROR,
    MIN_QUANTITY_ERROR,
    MIN_RATE_ERROR,
    QUANTITY_ERROR,
    RATE_ERROR,
    START_DATE_ERROR,
    UPLOAD_DOCUMENT_ERROR,
    UPLOAD_MAX_FILE_ERROR,
    UPLOAD_MAX_SIZE_ERROR,
    UPLOAD_PDF_ERROR,
    INVALID_CONTRACT_START_DATE,
    INVALID_CONTRACT_END_DATE,
    VALID_FORMAT_ERROR
} from '../utils/helpers/globalErrorMessage';

const EditContractValidation = () => {
    const [errors, setErrors] = useState({});

    const isValidFileType = (file) => {
        const allowedTypes = ["application/pdf"];
        return allowedTypes.includes(file.type);
    };

    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    const isValidDateFormat = (dateStr) => {
        const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
        return regex.test(dateStr);
    };

    const parseDate = (dateStr) => {
        return new Date(dateStr);
    };

    const noOfDaysfromCurrentDate = (startDate) => {
        const modifiedStartDate = new Date(startDate);
        const currentDate = new Date();
        const timeDifference = currentDate - modifiedStartDate;
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        return daysDifference;
    };

    const validateForm = (startDate, endDate, lineItems, contractTotal, files, contractDocument) => {
        let errors = {};
        errors.lineItems = [];
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            errors.startDate = START_DATE_ERROR;
        } else if (!isValidDateFormat(startDate)) {
            formIsValid = false;
            errors.startDate = VALID_FORMAT_ERROR;
        } else {
            const daysOld = noOfDaysfromCurrentDate(startDate);
            if (daysOld > 90) {
                formIsValid = false;
                errors.startDate = INVALID_CONTRACT_START_DATE;
            }
        }

        if (!endDate) {
            formIsValid = false;
            errors.endDate = END_DATE_ERROR;
        } else if (!isValidDateFormat(endDate)) {
            formIsValid = false;
            errors.endDate = VALID_FORMAT_ERROR;
        } else if (startDate && isValidDateFormat(startDate)) {
            const startDateObj = parseDate(startDate);
            const endDateObj = parseDate(endDate);
            if (endDateObj <= startDateObj) {
                formIsValid = false;
                errors.endDate = INVALID_CONTRACT_END_DATE;
            }
        }

        if (contractTotal === "0.00") {
            formIsValid = false;
            errors.contractTotal = MIN_AMOUNT_ERROR;
        }
        if (files.length === 0) {
            if (contractDocument.length === 0) {
                formIsValid = false;
                errors.files = UPLOAD_DOCUMENT_ERROR;
            }
            else {
                for (const item of contractDocument) {
                    if (!isValidFileType(item)) {
                        formIsValid = false;
                        errors.files = UPLOAD_PDF_ERROR;
                        break;
                    }
                    if (item.size > MAX_FILE_SIZE) {
                        formIsValid = false;
                        errors.files = UPLOAD_MAX_SIZE_ERROR;
                        break;
                    }
                    if (contractDocument.length > 5) {
                        formIsValid = false;
                        errors.files = UPLOAD_MAX_FILE_ERROR;
                        break;
                    }
                }
            }
        }
        else {
            for (const item of contractDocument) {
                if (!isValidFileType(item)) {
                    formIsValid = false;
                    errors.files = UPLOAD_PDF_ERROR;
                    break;
                }
                if (item.size > MAX_FILE_SIZE) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_SIZE_ERROR;
                    break;
                }
                if (contractDocument.length + files.length > 5) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_FILE_ERROR;
                    break;
                }
            }
        }

        lineItems.forEach((item, index) => {
            const lineItemErrors = {};

            if (!item.ItemId) {
                formIsValid = false;
                lineItemErrors.ItemId = ITEM_ERROR;
            }
            if (!item.Rate) {
                formIsValid = false;
                lineItemErrors.Rate = RATE_ERROR;
            }
            if (item.Rate && item.Rate == 0) {
                formIsValid = false;
                lineItemErrors.Rate = MIN_RATE_ERROR;
            }
            if (!item.Quantity) {
                formIsValid = false;
                lineItemErrors.Quantity = QUANTITY_ERROR;
            }
            if (item.Quantity && item.Quantity == 0) {
                formIsValid = false;
                lineItemErrors.Quantity = MIN_QUANTITY_ERROR;
            }
            if (Object.keys(lineItemErrors).length > 0) {
                errors.lineItems[index] = lineItemErrors;
            }
            return lineItemErrors;
        });

        if (errors.lineItems.length === 0) {
            delete errors.lineItems;
        }

        setErrors(errors);
        return formIsValid;
    };

    return { errors, setErrors, validateForm };
};

export default EditContractValidation;